import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button,  Input } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";

function YojanaMaster(props) {
  const [YojanaCode, setYojanaCode] = useState([]);
  const [YojanaName, setYojanaName] = useState('');
  const [YojanaNameEng, setYojanaNameEng] = useState('');
  const [Remark1, setRemark1] = useState('');
  const [UserID, setUserID] = useState('');

  const [units, setUnits] = useState([]);

  const [formMode, setFormMode] = useState('add');
  const [editchartId, setEditchartCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [YojanaMasterEntries, setYojanaMasterEntries] = useState([]);

  useEffect(() => {
    fetchYojanaMaster();
  }, []);

  const fetchYojanaMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/yojana');
      setYojanaMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setYojanaCode (nextEntryNo);
      console.log(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.YojanaCode > maxEntryNo) {
                maxEntryNo = entry.YojanaCode;
            }
        }
        return maxEntryNo;
    };

  const addYojana = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/yojana', {
        YojanaCode: YojanaCode,
        YojanaName: YojanaName,
        YojanaNameEng: YojanaNameEng,
        Remark1: Remark1,
        UserID: props.name,
      });
      fetchYojanaMaster();
      setYojanaCode('');
      setYojanaName('');
      setYojanaNameEng('');
      setRemark1('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateYojana = async (YojanaCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/yojana/${YojanaCode}`, {
        YojanaCode: YojanaCode,
        YojanaName: YojanaName,
        YojanaNameEng: YojanaNameEng,
        Remark1: Remark1,
        UserID: props.name,
      });
      fetchYojanaMaster();
      setYojanaCode('');
      setYojanaName('');
      setYojanaNameEng('');
      setRemark1('');
      setUserID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteYojana = async (YojanaCode) => {
    try {
      await axios.delete(`https://www.wingap.net.in/api/yojana/${YojanaCode}`, {
        headers: {
          'username': props.name,
        },
      });
      fetchYojanaMaster();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const setEditForm = (room) => {
    setFormMode('edit');
    setYojanaCode(room.YojanaCode);
    setYojanaName(room.YojanaName);
    setYojanaNameEng(room.YojanaNameEng);
    setRemark1(room.Remark1);
    setUserID(room.UserID);
    setShowGrid(false);
  };

  /* const handleSearch = (searchQuery) => {
    const filtered = units.filter((unit) => {
      const UnitId = unit.UnitId.toString().toLowerCase();
      const UnitName = unit.UnitName.toString().toLowerCase();
      const DeptCode = unit.DeptCode.toString().toLowerCase();
      const YearCode = unit.YearCode.toString().toLowerCase();
      const UserID = unit.UserID.toString().toLowerCase();

      return (
        UnitId.includes(searchQuery.toLowerCase()) ||
        UnitName.includes(searchQuery.toLowerCase()) ||
        DeptCode.includes(searchQuery.toLowerCase()) ||
        YearCode.includes(searchQuery.toLowerCase()) ||
        UserID.includes(searchQuery.toLowerCase())
      );
    });

    setchartMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, units]);*/

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setUnits(units);
  };

    const handleCancel = () => {
        setFormMode('add');
        setEditchartCode('');
        setYojanaCode('');
        setYojanaName('');
        setYojanaNameEng('');
        setRemark1('');
        setUserID('');
        fetchYojanaMaster();
    };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "chart Data",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });


  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Yojana Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>
          {formMode === 'add' ? 'Add' : 'Edit'}
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="YojanaCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              YojanaCode
            </label>
            <input
              type="text"
              value={YojanaCode}
              readOnly
              placeholder="YojanaCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="YojanaName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              YojanaName
            </label>
            <input
              type="text"
              value={YojanaName}
              onChange={(e) => setYojanaName(e.target.value)}
              placeholder="YojanaName"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>

          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="YojanaNameEng" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              YojanaNameEng
            </label>
            <input
              type="text"
              value={YojanaNameEng}
              onChange={(e) => setYojanaNameEng(e.target.value)}
              placeholder="YojanaNameEng"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>

          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Remark1" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              Remark1
            </label>
            <input
              type="text"
              value={Remark1}
              onChange={(e) => setRemark1(e.target.value)}
              placeholder="Remark1"
              style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="UserID" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
              UserID
            </label>
            <input
              type="text"
              value={UserID}
              readOnly
              onChange={(e) => setUserID(e.target.value)}
              placeholder="UserID"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addYojana : () => updateYojana(YojanaCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
        
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  YojanaCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  YojanaName 
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  YojanaNameEng 
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Remark1 
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {YojanaMasterEntries.map((chart) => (
                <tr key={chart.YojanaCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.YojanaCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.YojanaName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.YojanaNameEng}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{chart.Remark1}</td>

                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(chart)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteYojana(chart.YojanaCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default YojanaMaster;
